<!--
/**
  * 多选按钮组件
  * @author weili
  */
-->
<template>
   <el-checkbox-group 
      v-model="formData[`${value}Group`]"
      :disabled="disabled"
      :showOptions="showOptions"
      :hideOptions="hideOptions"
      @change="
            handleEvent(
              formData[`${value}Group`]
            )
          "
      style="width:100%;"
    >
    <el-checkbox-button
         v-for="childItem in listTypeInfo" 
        :label="childItem.value" :key="childItem.value">{{childItem.label}}</el-checkbox-button>
  </el-checkbox-group>

</template>
<script>
import mixin from '@/mixins/mixin'
export default {
    name: 'EXCheckButton',
    mixins: [mixin],
    props: {
        //表单
        formData: {
        type: Object,
        default:{}
        },
        //字段名
        value: {
        type: String,
        default:""
        },
        //是否禁用
        disabled: {
        type: Boolean,
        default: false,
        },
        //字典名称
        dicCode :{
          type: String,
          default: "",
        },
        //回调函数
        change: Function,
        //初始化数据项，使用非字典时可用
        listData:{
          type: Array,
          default:()=>[]
        },
        //显示指定的数据项
        showOptions: {
          type: Array,
          default:()=>[]
        },
        //隐藏指定的数据项
        hideOptions: {
          type: Array,
          default:()=>[]
        },
    },
    data() {
        return {
          listTypeInfo: []
        }
    },
    watch: { 
      formData(val){
        this.initListTypeInfo()
      },
      listData(val) {
        this.initListTypeInfo()
      },
      dicCode(val) {
        this.initListTypeInfo()
      },
      hideOptions(val){
        this.initListTypeInfo()
      },
      showOptions(val){
        this.initListTypeInfo()
      }
    },
    created(){
      this.initListTypeInfo()
    },
    methods: {
        // 绑定的相关事件
        handleEvent(value) {
            //将数组group值转换成字符串
          var str = value.join()
          this.$set(this.formData, this.value, str); //回填表单值
          this.$forceUpdate();
           this.$emit("change", str);
        },
        //初始化字典下拉框
        initListTypeInfo(){
            if(this.dicCode && this.dicCode.trim().length > 0){
              this.mixFeignDictDataList(this.dicCode).then((list)=>{
                this.listTypeInfo = list
                this.handleSelectOptions()
              })
            }else{
                this.listTypeInfo = this.listData
                this.handleSelectOptions()
            }
            var value = this.formData[value]
            let ids = []
            if (value) {
              ids = value.split(',')
            }
            this.$set(this.formData, `${value}Group`, ids);
            this.$forceUpdate()
        },
        //设置下拉框选项显示/隐藏
        handleSelectOptions(){
          const list =  this.listTypeInfo
          if(this.showOptions && this.showOptions.length > 0){
            let data = []
            for(var i = 0; i < list.length; i++){
              for(var j = 0; j < this.showOptions.length; j++){
                  if(list[i].value == this.showOptions[j]){
                        data.push(list[i])
                        break;
                  }
              }
            }
            this.listTypeInfo = data
          }
          if(this.hideOptions && this.hideOptions.length > 0){
            let data = []
            data = data.concat(list)  //浅拷贝，避免修改字典数组
            for(var i = 0; i < list.length; i++){
              for(var j = 0; j < this.hideOptions.length; j++){
                  if(list[i].value == this.hideOptions[j]){
                        data.splice(i, 1);
                        break;
                  }
              }
            }
            this.listTypeInfo = data
          }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/EXForm/EXCheckButton.vue